import { errorUtilities } from '../common';

const validateEmailRegex = /[A-z0-9._%+-]+@[A-z0-9]+\.[A-z]{2,6}/;

export function isValidEmail(email) {
  return validateEmailRegex.test(email);
}

export function invalidEmailError(id, label, section, errorNum) {
  return errorUtilities.validationError(id, label, section, errorNum, "Please enter a valid email address.", errorUtilities.errorTypes.inline);
}



// WEBPACK FOOTER //
// src/common/email-utilities.js